@if (menu$ | async; as menu) {
  @if (menu.filter$ | async) {
    <div class="menu flex-container flex-column" [class.admin-menu]="isApplicationAdmin" role="navigation">
      @let overflowState = overflow$ | async;
      <div #menuBody class="menu-body full flex-grow">
        <ul>
          @for (entry of menu.entries; track entry.name) {
            @if (entry.renderAs === MenuEntryType.UserPreferences) {
              <li [attr.data-menu-entry]="entry.name" [class.menu-entry-overflowed]="overflowState.entryNames.has(entry.name)">
                <ng-container *ngTemplateOutlet="userPreferences"></ng-container>
              </li>
            } @else if (entry.renderAs === MenuEntryType.Companion && (entry.filter$ | async)) {
              <li [attr.data-menu-entry]="entry.name" [class.menu-entry-overflowed]="overflowState.entryNames.has(entry.name)">
                @if (menu.separatorPositions && menu.separatorPositions.includes(entry.name)) {
                  <div class="menu-separator"></div>
                }
                <nimbus-companion-menu-item [entry]="entry"></nimbus-companion-menu-item>
              </li>
            } @else if (!entry.renderAs && (entry.filter$ | async)) {
              <li [attr.data-menu-entry]="entry.name" [class.menu-entry-overflowed]="overflowState.entryNames.has(entry.name)">
                @if (menu.separatorPositions && menu.separatorPositions.includes(entry.name)) {
                  <div class="menu-separator"></div>
                }
                <nimbus-menu-item [entry]="entry"></nimbus-menu-item>
              </li>
            }
          }
        </ul>
        @if (overflowState.entries.length) {
          <nimbus-menu-overflow-item
            class="menu-overflow"
            [style.top.px]="overflowState.top"
            [entries]="overflowState.entries"
            [active]="overflowState.active"
            [hasPermissionNotification]="hasPermissionNotification$ | async"
          ></nimbus-menu-overflow-item>
        }
      </div>
      <div class="menu-footer">
        <ul>
          @for (entry of menu.footerEntries; track entry.name) {
            <li>
              @if (entry.filter$ | async) {
                <nimbus-menu-item [entry]="entry" [id]="'menu-footer-entry' + entry.name"></nimbus-menu-item>
              }
            </li>
          }
          @if (isApplicationPortal && (hasCcLicense$ | async)) {
            <li id="on-duty">
              <nimbus-agent-assistant></nimbus-agent-assistant>
            </li>
          }
          @if (menu.brand) {
            <li>
              <a
                class="flex-container flex-align-center menu-item menu-item-active"
                id="menu-brand"
                tabindex="0"
                role="link"
                (click)="navigateToExternalUrl(menu.brand)"
                (keydown.enter)="navigateToExternalUrl(menu.brand)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i [nimbusIcon]="menu.brand.icon"></i>
                <ng-container *ngTemplateOutlet="menuTooltip; context: { item: menu.brand.name }"></ng-container>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  }

  <ng-template #menuTooltip let-Item="item">
    @if (Item) {
      <nimbus-tooltip [text]="Item" position="right" [theme]="ChartTheme.Dark"></nimbus-tooltip>
    }
  </ng-template>
}

<ng-template #userPreferences>
  <span
    class="flex-container flex-align-center menu-item nav"
    tabindex="0"
    role="button"
    [class.menu-item-active]="url === '/authentication/login' || url.startsWith('/user-preferences')"
    (click)="openUserPreferencesPage()"
    (keydown.enter)="openUserPreferencesPage()"
  >
    <nimbus-icon
      class="warning"
      [icon]="Icons.USER_SETTINGS"
      [markIcon]="Icons.EXCLAMATION_TRIANGLE"
      [marked]="hasPermissionNotification$ | async"
    ></nimbus-icon>
    <nimbus-tooltip [text]="TranslationKeys.UserPreferencesTitle | translate" position="right" [theme]="ChartTheme.Dark"></nimbus-tooltip>
  </span>
</ng-template>
